'use client';

import { c as _c } from "react/compiler-runtime";
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { FilterOption } from '../constants';
import { FilterCheckboxList } from './FilterCheckboxList';
import { FilterChipGroup } from './FilterChipGroup';
import { FilterSection } from './FilterSection';
interface MultiSelectFilterSectionProps<TQueryFnData, TError, TQueryKey extends QueryKey> {
  variant: 'sidebar' | 'drawer';
  title: string;
  queryOptions: UseQueryOptions<TQueryFnData, TError, FilterOption<string>[], TQueryKey>;
  values: string[];
  onToggle: (value: string) => void;
  skeletonCount?: number;
}
export function MultiSelectFilterSection(t0) {
  const $ = _c(24);
  const {
    variant,
    title,
    queryOptions,
    values,
    onToggle,
    skeletonCount: t1
  } = t0;
  const skeletonCount = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== queryOptions) {
    t2 = {
      ...queryOptions,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = queryOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: t3,
    isLoading
  } = useQuery(t2);
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const options = t4;
  if (!isLoading && options.length < 1) {
    return null;
  }
  if (variant === "sidebar") {
    let t5;
    if ($[4] !== isLoading || $[5] !== onToggle || $[6] !== options || $[7] !== skeletonCount || $[8] !== values) {
      t5 = <FilterCheckboxList options={options} selectedValues={values} onToggle={onToggle} isLoading={isLoading} skeletonCount={skeletonCount} />;
      $[4] = isLoading;
      $[5] = onToggle;
      $[6] = options;
      $[7] = skeletonCount;
      $[8] = values;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t5 || $[11] !== title) {
      t6 = <FilterSection title={title}>{t5}</FilterSection>;
      $[10] = t5;
      $[11] = title;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t5;
  if ($[13] !== title) {
    t5 = <h3 className="font-700 text-Gray-900 typo-body4">{title}</h3>;
    $[13] = title;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isLoading || $[16] !== onToggle || $[17] !== options || $[18] !== skeletonCount || $[19] !== values) {
    t6 = <FilterChipGroup options={options} selectedValues={values} onToggle={onToggle} isLoading={isLoading} skeletonCount={skeletonCount} />;
    $[15] = isLoading;
    $[16] = onToggle;
    $[17] = options;
    $[18] = skeletonCount;
    $[19] = values;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t5 || $[22] !== t6) {
    t7 = <div className="flex flex-col gap-12">{t5}{t6}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}